import { Builder } from '@builder.io/react';
import Product from './product';
import theme from '../../utilities/brandTheme';

Builder.registerComponent(Product, {
  name: 'Product',
  static: true,
  inputs: [
    {
      name: 'image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'gif'],
      required: false,
    },
    {
      name: 'alt',
      type: 'string',
      required: false,
      defaultValue: '',
    },
    {
      name: 'title1',
      type: 'string',
      required: false,
      defaultValue: '',
    },
    {
      name: 'title2',
      type: 'string',
      required: false,
      defaultValue: '',
    },
    {
      name: 'subtitle',
      type: 'string',
      required: false,
      defaultValue: false,
      helperText: 'Displays Alt as caption below the image',
    },
    {
      name: 'buttonText',
      type: 'string',
      required: false,
      defaultValue: false,
      helperText: 'Displays Alt as caption below the image',
    },
    {
      name: 'strikedPrice',
      type: 'string',
      required: false,
      defaultValue: false,
      helperText: 'Displays Alt as caption below the image',
    },
    {
      name: 'price',
      type: 'string',
      required: false,
      defaultValue: false,
      helperText: 'Displays Alt as caption below the image',
    },
    {
      name: 'bottomText',
      type: 'string',
      required: false,
      defaultValue: false,
      helperText: 'Displays Alt as caption below the image',
    },
    {
      name: 'bannerImage',
      type: 'string',
      required: false,
      defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2Ff9dd6bab38b6461a948dbc919c8394de%2F5bc38e9918d14ce68564983415c04722',
      friendlyName: 'Banner Image URL',
    },
    {
      name: 'textAlign',
      type: 'string',
      required: false,
      enum: [
        'start',
        'center',
        'end',
        'justify',
        'justify-all',
        'match-parent',
      ],
      defaultValue: 'center',
    },
    {
      name: 'textStyles',
      type: 'string',
      enum: theme.styles.textStyles,
      defaultValue: 'default',
    },
    {
      name: 'textColor',
      type: 'string',
      enum: theme.styles.textColors,
      defaultValue: 'default',
    },
    {
      name: 'buttonType',
      type: 'string',
      enum: Object.keys(theme.buttons).filter(key => key !== 'arrow' && key !== 'primaryMando'),
      defaultValue: 'primary',
      friendlyName: 'Button Style',
    },
    
  ],
});
